<template>
    <b-modal
            ref="modal"
            centered
            scrollable
            size="lg"
            class="text-left"
            @ok="emitEditDeals"
    >
        <b-button size='sm' class="mb-2" variant='primary' v-on:click=selectAllDeals()>
            Check all
        </b-button>
        <b-button size='sm' class="mb-2" variant='primary' v-on:click=unselectAllDeals()>
            Uncheck all
        </b-button>
        <div slot="modal-title">
            {{this.user.Username}} - Edit deals
        </div>
        <div class="mb-3"></div>
        <b-form-group>
            <b-row class="text-nowrap">
                <b-col>
                    <b-form-checkbox-group
                            stacked
                            v-model="dealsSelected"
                            text-field="DealName"
                            value-field="DealName"
                            :options="dealsCol0"
                    />
                </b-col>
                <b-col>
                    <b-form-checkbox-group
                            stacked
                            v-model="dealsSelected"
                            text-field="DealName"
                            value-field="DealName"
                            :options="dealsCol1"
                    />
                </b-col>
                <b-col>
                    <b-form-checkbox-group
                            stacked
                            v-model="dealsSelected"
                            text-field="DealName"
                            value-field="DealName"
                            :options="dealsCol2"
                    />
                </b-col>
            </b-row>
        </b-form-group>
    </b-modal>
</template>

<script>
  export default {
    data() {
      return {
        user: {},
        deals: [],
        dealsSelected: [],
        nOfColInEditDeals: 3
      };
    },
    computed: {
      dealsCol0() {
        return this.deals.slice(this.calculateColBegIndex(this.deals.length, 0), this.calculateColEndIndex(this.deals.length, 0));
      },
      dealsCol1() {
        return this.deals.slice(this.calculateColBegIndex(this.deals.length, 1), this.calculateColEndIndex(this.deals.length, 1));
      },
      dealsCol2() {
        return this.deals.slice(this.calculateColBegIndex(this.deals.length, 2), this.calculateColEndIndex(this.deals.length, 2));
      }
    },
    methods: {
      showModal(user, deals) {
        this.user = user;
        this.deals = deals;
        this.dealsSelected = this.deals.map(el => {
          if (Boolean(el.IsAssigned) === true) {
            return el.DealName;
          }
        });
        this.$refs.modal.show();
      },
      selectAllDeals() {
        this.dealsSelected = this.deals.map(el => {
          return el.DealName;
        });

      },
      unselectAllDeals() {
        this.dealsSelected = [];
      },
      calculateColBegIndex(arrayLength, currentColumnIndex) {
        return Math.ceil(this.deals.length / this.nOfColInEditDeals * currentColumnIndex);
      },
      calculateColEndIndex(arrayLength, currentColumnIndex) {
        return Math.ceil(this.deals.length / this.nOfColInEditDeals * (currentColumnIndex + 1));
      },
      emitEditDeals() {
        this.deals = this.deals.map(el => {
          if (this.dealsSelected.includes(el.DealName)) {
            el.IsAssigned = true;
          } else {
            el.IsAssigned = false;
          }
          return el;
        });
        this.$emit('editDeals', this.user, this.deals)
      }
    }
  };
</script>
